'use client';

import { CSSProperties } from 'react';
import { useTranslations } from 'next-intl';
import { CustomImage as Image } from '../..';
import { useWindowSize } from 'hooks/dom/useWindowSize';
import { getCompressedAssetUrl } from 'lib/config/assetUrls';
import styles from './SleepStagesModal.module.css';

export const SleepStagesModal = ({ className }: { className?: string }) => {
  const t = useTranslations('ring');
  const { width } = useWindowSize();
  return (
    <div
      className={className ? `${styles.root} ${className}` : styles.root}
      onClick={(e) => e.stopPropagation()}
      onKeyDown={(e) => e.stopPropagation()}
      role="button"
      tabIndex={0}
      aria-labelledby="sleep-stages-modal-heading"
    >
      <div className="container">
        <h4 id="sleep-stages-modal-heading">
          {t('ring.bentoSleepSection.sleepStagesCard.modal.head')}
        </h4>
        <h3>{t('ring.bentoSleepSection.sleepStagesCard.modal.subHead')}</h3>
        <div className="modal-items">
          <div className="item">
            <p className="text-mid">
              {t('ring.bentoSleepSection.sleepStagesCard.modal.cardA.desc')}
            </p>
            <div
              className="img-container"
              role="img"
              aria-label={t(
                'sleepStagesModal.content.ariaLabel.sleepStagesVisualization',
              )}
            >
              <Image
                src={'web_v2/ring-buy/sleep/svg/flip/sleepStagesFlipA.svg'}
                fill
                alt=""
                className="sleep-index"
                aria-hidden="true"
              />
            </div>
          </div>
          <div
            className="item"
            style={
              {
                '--item-bg': `url(${getCompressedAssetUrl(
                  '/web_v2/ring-buy/sleep/png/flip/sleepStagesFlipBresp.png',
                )})`,
                '--item-bg-lg': `url(${getCompressedAssetUrl(
                  '/web_v2/ring-buy/sleep/png/stagesBg.png',
                )})`,
              } as CSSProperties
            }
          >
            <p className="text-mid">
              {t('ring.bentoSleepSection.sleepStagesCard.modal.cardB.desc')}
            </p>
            {width > 992 ? (
              <div
                className="img-container"
                role="img"
                aria-label={t(
                  'sleepStagesModal.content.ariaLabel.sleepStagesDetailed',
                )}
              >
                <Image
                  src={'web_v2/ring-buy/sleep/svg/flip/sleepStagesFlipBA.svg'}
                  fill
                  alt=""
                  className="sleep-index"
                  aria-hidden="true"
                />
              </div>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
};
